export interface ActionCardInterface {
  variant: 'withDescription' | 'withTitleIcon' | 'withTitleIconDescription'
  button: React.ReactElement
  title?: string
  description?: string
  iconClass?: string
  iconImg?: React.ReactElement
  backgroundColor?: string
  className?: string
}

export const ActionCard = ({
  variant,
  title,
  description,
  iconClass,
  iconImg,
  button,
  backgroundColor,
  className,
}: ActionCardInterface): JSX.Element => {
  const getContentAccordingVariant = (variant: string) => {
    switch (variant) {
      case 'withDescription':
        return (
          <div className="d-flex flex-row justify-content-between align-items-center">
            <div className="d-flex flex-column justify-content-start pe-4">
              <h4 className="mb-2">{title}</h4>
              <p>{description}</p>
            </div>
            {button}
          </div>
        )
      case 'withTitleIcon':
        return (
          <div className="d-flex flex-row justify-content-between align-items-center">
            <div className="d-flex flex-row justify-content-start align-items-center pe-4">
              {iconClass && <i className={iconClass}></i>}
              {iconImg && iconImg}
              <h4 className="m-0 p-0 ms-4">{title}</h4>
            </div>
            {button}
          </div>
        )
      case 'withTitleIconDescription':
        return (
          <div className="d-flex flex-row justify-content-between align-items-center">
            <div className="d-flex flex-row justify-content-start align-items-center pe-4">
              {iconClass && <i className={iconClass}></i>}
              {iconImg && iconImg}
              <div className="ms-4">
                <h4 className="m-0 p-0 mb-2">{title}</h4>
                {description && <p className="m-0">{description}</p>}
              </div>
            </div>
            {button}
          </div>
        )
    }
  }

  return (
    <div
      className={`action-card-container ${className}`}
      style={{
        backgroundColor: !backgroundColor ? 'white' : backgroundColor,
      }}
    >
      {getContentAccordingVariant(variant)}
    </div>
  )
}
